import { landingContent } from "../../data/landingContent";
import { getLocalizedPath } from "../../data/guideAlternates";
import { getLocale, setLocale, type SupportedLocale } from "../../i18n";
import { Link, useLocation, useNavigate } from "react-router-dom";

export function Header() {
  const { header } = landingContent;
  const currentLocale = getLocale();
  const location = useLocation();
  const navigate = useNavigate();
  const homePath = getLocalizedPath(location.pathname, currentLocale);

  const handleLocaleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const nextLocale = e.target.value as SupportedLocale;
    setLocale(nextLocale);
    const nextPath = getLocalizedPath(location.pathname, nextLocale);
    if (nextPath !== location.pathname) {
      navigate(nextPath);
      return;
    }
    window.location.reload();
  };

  return (
    <header className="st-header">
      <Link className="st-logo" to={homePath} aria-label="Stalkie home">
        <img
          src="/landing/icon.png"
          alt=""
          aria-hidden="true"
          style={{ width: "24px", height: "24px", borderRadius: "5px" }}
        />
        <span>{header.logo}</span>
      </Link>

      <div className="st-header-actions">
        <select
          value={currentLocale}
          onChange={handleLocaleChange}
          className="st-lang-select"
          aria-label="Change language"
        >
          <option value="en">🇺🇸 English</option>
          <option value="pt">🇧🇷 Português</option>
          <option value="es">🇪🇸 Español</option>
        </select>

        <Link to="/auth/login" className="st-login">
          {header.loginLabel}
        </Link>

        <a href="#top" className="st-header-cta">
          {header.ctaLabel}
        </a>
      </div>
    </header>
  );
}
